// This should be imported before anything else as suggested by the Sentry docs:
// https://docs.sentry.io/platforms/javascript/guides/node/
import './sentry';

import type { FC, PropsWithChildren } from 'react';

import { I18nProvider, ThemeProvider, useAxe } from '@cofenster/web-components';

import { Translations } from '../Translations';
import { ErrorBoundary } from './components/ErrorBoundary';

const STAGE = process.env.STAGE as string;

export const App: FC<PropsWithChildren<{ defaultLang: 'EN' | 'DE' }>> = ({ children, defaultLang }) => {
  useAxe(STAGE);

  return (
    <ThemeProvider>
      <I18nProvider translations={Translations} defaultLocale={defaultLang}>
        <ErrorBoundary>{children}</ErrorBoundary>
      </I18nProvider>
    </ThemeProvider>
  );
};
